import { useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedQuery } from 'flow/hooks/api/useAuthenticatedQuery';
import RecordedCallsResource from 'flow/api/recordedcalls';
import { RecordedCallKey } from 'flow/types/EntityKeys';
import { Transcription } from 'flow/types/Transcription';

export const useGetRecordedCallTranscription = (
    recordedCallKey: RecordedCallKey | undefined,
    isPersonalRecording: boolean | undefined,
    enabled: boolean = false,
    staleTime = Infinity,
    retry: boolean = true,
) => {
    const queryClient = useQueryClient();
    const queryKey = ['transcribe', recordedCallKey];
    const { data, isFetching, refetch } = useAuthenticatedQuery({
        queryKey,
        queryFn: () =>
            new Promise<Transcription>((resolve, reject) => {
                RecordedCallsResource.getTranscription(
                    {
                        onResult: resolve,
                        onError: reject,
                        onClientError: reject,
                    },
                    recordedCallKey,
                    isPersonalRecording,
                );
            }),
        enabled,
        staleTime,
        retry,
        refetchOnWindowFocus: false,
    });

    const invalidateCache = () => {
        queryClient.invalidateQueries({ queryKey });
    };

    return {
        data,
        isFetching,
        refetch,
        invalidateCache,
    };
};
